/** Site-wide JavaScript definitions and settings */

GOOGLE_MAPS_API_KEY = 'AIzaSyC1gXXtDZjFkzbpgHnUxbI2nZekpQZg5nE';